import type { Author } from "@/lib/authors";

export function AuthorBio({ author }: { author: Author }) {
  const initials = author.name
    .split(/\s+/)
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  const bio = author.bio?.trim();
  return (
    <aside
      id={author.slug}
      className="mt-12 flex gap-5 border-t border-border pt-6"
      aria-label={`About ${author.name}`}
    >
      <div
        aria-hidden
        className="shrink-0 h-14 w-14 rounded-full bg-paper-soft border border-border grid place-items-center font-serif text-lg text-ochre-deep overflow-hidden"
      >
        {author.avatar ? (
          <img src={author.avatar} alt="" className="h-full w-full object-cover" />
        ) : (
          initials
        )}
      </div>
      <div className="flex-1">
        <p className="eyebrow">Written by</p>
        <p className="mt-1 font-semibold text-base">
          <a href={author.url} className="hover:text-accent">
            {author.name}
          </a>
        </p>
        {bio && (
          <p className="mt-2 text-sm text-foreground/80 leading-relaxed whitespace-pre-line">
            {bio}
          </p>
        )}
        <p className="mt-2 text-xs flex flex-wrap gap-x-3 gap-y-1">
          {author.linkedin && (
            <a
              href={author.linkedin}
              target="_blank"
              rel="noopener noreferrer me"
              className="text-ochre-deep hover:text-accent underline"
            >
              LinkedIn ↗
            </a>
          )}
          {author.twitter && (
            <a
              href={author.twitter}
              target="_blank"
              rel="noopener noreferrer me"
              className="text-ochre-deep hover:text-accent underline"
            >
              Twitter / X ↗
            </a>
          )}
          {author.website && (
            <a
              href={author.website}
              target="_blank"
              rel="noopener noreferrer me"
              className="text-ochre-deep hover:text-accent underline"
            >
              Website ↗
            </a>
          )}
        </p>
      </div>
    </aside>
  );
}
